import React from 'react';
import {
    Checkbox,
    FormControlLabel,
    TextField,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Button from '@material-ui/core/Button';
import {FieldRenderProps} from 'react-final-form-hooks';

import '../Users.scss';
import {OnChange} from '../UserDetails/UserTypes';

interface UserAddProps {
    pushRouteToHistory: () => void;
    emailField: FieldRenderProps;
    isNotValid: boolean;
    plutoEmailErrorMessage: string[];
    invalidEmailErrorMessage: string[];
    roleErrorMessage: string[];
    emailExistsMessage: string;
    rolesField: FieldRenderProps;
    onChangeRole: (roleField: FieldRenderProps, role: string) => OnChange;
    onSaveHandler: () => void;
}

export default function UserAdd(props: UserAddProps) {
    const {
        pushRouteToHistory,
        emailField,
        isNotValid,
        plutoEmailErrorMessage,
        invalidEmailErrorMessage,
        roleErrorMessage,
        emailExistsMessage,
        rolesField,
        onChangeRole,
        onSaveHandler,
    } = props;
    
    return (
        <div className="add-user">
            <div className="add-user__title">
            Add User
            </div>
            <div className="add-user__email">
                <div>
                    Email:
                </div>
                <TextField
                    value={emailField.input.value}
                    onChange={emailField.input.onChange}
                    className="add-user__email-input"
                    autoComplete="off"
                    id="email"
                    name="email"
                    label="Pluto email"
                    variant="outlined"
                />
            </div>
            <div className="add-user__emailError">
                <span>
                    {plutoEmailErrorMessage}
                    {invalidEmailErrorMessage}
                    {emailExistsMessage}
                </span>
            </div>
            <div className="add-user__roles">
                <div>
                    <FormControl>
                        <div className="add-user__roles-title">
                            User Roles:
                        </div>
                        <FormGroup>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        value={rolesField.input.value.admin}
                                        onChange={onChangeRole(rolesField, 'admin')}
                                        name="admin"
                                    />
                                )}
                                label="Administrator"
                            />
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        value={rolesField.input.value.qcOperator}
                                        onChange={onChangeRole(rolesField, 'qcOperator')}
                                        name="qcOperator"
                                    />
                                )}
                                label="QC Operator"
                            />
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        value={rolesField.input.value.contentOpsCoordinator}
                                        onChange={onChangeRole(rolesField, 'contentOpsCoordinator')}
                                        name="contentOps"
                                    />
                                )}
                                label="Content Ops Coordinator"
                            />
                            <div className="add-user__roleError">
                                <span>{roleErrorMessage}</span>
                            </div>
                        </FormGroup>
                    </FormControl>
                </div>
            </div>
            <div className="add-user__buttons">
                <Button
                    className="add-user__buttons_cancel"
                    onClick={pushRouteToHistory}
                    variant="contained"
                >
                    Cancel
                </Button>
                <Button
                    disabled={isNotValid}
                    className="add-user__buttons-add"
                    onClick={onSaveHandler}
                    variant="contained"
                >
                    Add
                </Button>
            </div>
        </div>
    );
}
